import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import Unit from "./Unit";
var TextInput = function TextInput(props) {
  var label = props.label,
    value = props.value,
    _onChange = props.onChange,
    name = props.name,
    id = props.id,
    placeholder = props.placeholder,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    required = props.required,
    disabled = props.disabled,
    type = props.type,
    inputMode = props.inputMode,
    min = props.min,
    max = props.max,
    maxLength = props.maxLength,
    inputRef = props.inputRef,
    isClinicalField = props.isClinicalField,
    _props$wrapperClassNa = props.wrapperClassName,
    wrapperClassName = _props$wrapperClassNa === void 0 ? "" : _props$wrapperClassNa,
    _props$inputClassName = props.inputClassName,
    inputClassName = _props$inputClassName === void 0 ? "" : _props$inputClassName,
    _props$labelClassName = props.labelClassName,
    labelClassName = _props$labelClassName === void 0 ? "" : _props$labelClassName,
    _props$parentClassNam = props.parentClassName,
    parentClassName = _props$parentClassNam === void 0 ? "" : _props$parentClassNam,
    unit = props.unit,
    onChangeUnit = props.onChangeUnit,
    leftContent = props.leftContent,
    rightContent = props.rightContent,
    defaultValue = props.defaultValue,
    error = props.error,
    _onClick = props.onClick,
    subLabel = props.subLabel,
    readOnly = props.readOnly;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!subLabel && /*#__PURE__*/React.createElement("p", {
    className: "text-md text-left"
  }, subLabel), /*#__PURE__*/React.createElement("div", {
    className: classNames("relative rounded-md py-3 px-2 text-gray-900 dark:text-gray-100", _defineProperty({
      "border border-gray-500": !isClinicalField,
      "opacity-70": disabled
    }, wrapperClassName, !!wrapperClassName))
  }, !!label && /*#__PURE__*/React.createElement("label", {
    className: classNames("text-md", _defineProperty({
      "dark:bg-gray-800 bg-gray-200 absolute left-4 -top-3 px-4": !isClinicalField,
      "dark:bg-transparent flex mb-5 text-base": isClinicalField
    }, labelClassName, !!labelClassName))
  }, label, " ", !!required && /*#__PURE__*/React.createElement("span", {
    className: "text-red-500 pl-2"
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center", _defineProperty({}, parentClassName, !!parentClassName))
  }, leftContent && leftContent(), /*#__PURE__*/React.createElement("div", {
    className: classNames("rounded dark:border-0 w-full flex-1", _defineProperty({
      "bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-none pb-2 px-3": isClinicalField
    }, className, !!className))
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: type || "text",
    value: value,
    onChange: function onChange(e) {
      return _onChange ? _onChange(e.target.value) : null;
    },
    onClick: function onClick(e) {
      return _onClick ? _onClick(e) : {};
    },
    name: name,
    id: id,
    defaultValue: defaultValue,
    placeholder: placeholder,
    className: classNames("block bg-gray-200 dark:bg-transparent w-full border-0 pb-3", _defineProperty({
      "border-b border-gray-400 dark:border-gray-200 text-center !pb-0": isClinicalField,
      "hover:!border-teal-500": !disabled,
      "!border-red-600 hover:!border-red-600": isClinicalField && !!error
    }, inputClassName, !!inputClassName)),
    required: required,
    disabled: disabled,
    inputMode: inputMode,
    maxLength: maxLength,
    min: min,
    max: max,
    readOnly: readOnly
  }), isClinicalField && !!error && /*#__PURE__*/React.createElement("p", {
    className: "text-red-600 pt-2 font-medium text-md"
  }, error)), /*#__PURE__*/React.createElement("div", null, rightContent && rightContent()), /*#__PURE__*/React.createElement(Unit, {
    unit: unit,
    onChangeUnit: onChangeUnit
  }))));
};
export default TextInput;